import { useMemo } from 'react'

import { ArticleStyleProperty } from 'types'

const SUPPORTED_SELECTORS = ['p', 'h1', 'h2', 'h3', 'h4'] as const

export const useComputedEditorStyles = (
  editorElement: HTMLElement | null,
  deps = [] as any[],
): { [selector in typeof SUPPORTED_SELECTORS[number]]: Required<ArticleStyleProperty> } =>
  useMemo(
    () =>
      SUPPORTED_SELECTORS.reduce((styles, selector) => {
        const computedStyles = window.getComputedStyle(
          editorElement?.querySelector(`.ProseMirror > ${selector}`) || document.body,
        )

        return {
          ...styles,
          [selector]: {
            background_color: computedStyles.backgroundColor,
            color: computedStyles.color,
            font_family: computedStyles.fontFamily.replaceAll('"', '').split(',')[0],
            font_size: computedStyles.fontSize,
            font_style: computedStyles.fontStyle,
            font_weight: computedStyles.fontWeight,
            line_height: parseFloat(computedStyles.lineHeight) / parseFloat(computedStyles.fontSize),
            padding_bottom: computedStyles.paddingBottom,
            padding_top: computedStyles.paddingTop,
            text_align: computedStyles.textAlign,
            text_decoration: computedStyles.textDecorationLine,
            text_transform: computedStyles.textTransform,
          },
        }
      }, {}) as ReturnType<typeof useComputedEditorStyles>,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [editorElement, ...deps],
  )
